export default "__VITE_ASSET__BiOUZt_1__"